import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTableGT2A from '../common/grid/gridReactTable';
import { getConfig } from '../configuracao/configLocal';
import { parseISO, format, isValid } from 'date-fns';
import TooltipWrapper from '../common/form/TooltipWrapper';

class LogAdaptativoList extends Component {
  // Função para formatar tempo (mesmo padrão de outras telas)
  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  // Função para lidar com mudança de tempo
  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  carregaColunas() {
    const { list } = this.props;

    const columns = [
      {
        Header: 'Data',
        accessor: 'data',
        minWidth: 100,
        maxWidth: 120,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        // Filtro e ordenação habilitados
        filterable: true,
        resizable: true,
        sortable: true,
        className: 'column_grid column_center',
        // Filtro de data igual ao de outras telas
        Filter: ({ filter, onChange }) => (
          <input
            type="date"
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
            className="form-control"
          />
        ),
        // Método de filtro para comparar datas
        filterMethod: (filter, row) => {
          if (!filter.value) return true;

          // Para linhas que não têm data (linhas 2 e 3 do ciclo), usar a data original a partir do _original
          const original = row && row._original ? row._original : null;
          const dataRow = row[filter.id] || (original && original.data_original);
          if (!dataRow) return false;

          try {
            const partesData = dataRow.split('/');
            if (partesData.length === 3) {
              const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;
              return dataFormatada === filter.value;
            }
          } catch (error) {
            console.warn('Erro ao processar filtro de data:', error);
          }
          return false;
        },
        // Função de ordenação personalizada que mantém as duas linhas juntas
        sortMethod: (a, b, desc) => {
          // Usar timestamp para ordenação mais precisa
          const aTimestamp = a.original ? a.original.timestamp_original : 0;
          const bTimestamp = b.original ? b.original.timestamp_original : 0;
          const aKey = a.original ? a.original.ordenacao_key : '';
          const bKey = b.original ? b.original.ordenacao_key : '';

          // Se for o mesmo timestamp (mesmo ciclo), usar ordenacao_key para manter ordem das linhas
          if (aTimestamp === bTimestamp) {
            if (aKey < bKey) return -1;
            if (aKey > bKey) return 1;
            return 0;
          }

          // Para diferentes timestamps, aplicar ordenação
          // Por padrão (desc=false), mais recente no topo (timestamp maior primeiro)
          // Quando desc=true, mais antigo no topo (timestamp menor primeiro)
          if (desc) {
            return aTimestamp - bTimestamp; // Crescente (mais antigo primeiro)
          } else {
            return bTimestamp - aTimestamp; // Decrescente (mais recente primeiro)
          }
        },
      },
      {
        Header: 'Hora',
        accessor: 'hora',
        minWidth: 80,
        maxWidth: 100,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        // Filtro de hora habilitado
        filterable: true,
        resizable: true,
        sortable: false,
        className: 'column_grid column_center',
        // Filtro de hora igual ao de outras telas
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
            style={{ width: '100%', textAlign: 'center' }}
          />
        ),
        // Método de filtro para hora que considera dados originais para linhas sem hora visível
        filterMethod: (filter, row) => {
          if (!filter.value) return true;

          // Para linhas que não têm hora (linhas 2 e 3 do ciclo), usar dados originais via _original
          const original = row && row._original ? row._original : null;
          const horaRow = row[filter.id] || (original && original.dadosOriginais && original.dadosOriginais.hora);
          if (!horaRow) return false;

          // Filtro inteligente: verifica se a hora começa com o texto digitado
          const horaString = String(horaRow).toLowerCase();
          const filtroString = String(filter.value).toLowerCase();
          
          // Se o filtro tem formato HH, HH:MM ou HH:MM:SS, fazer match exato da parte digitada
          const partesHora = horaString.split(':');
          const partesFiltro = filtroString.split(':');
          
          // Verificar cada parte (hora, minuto, segundo) conforme o que foi digitado
          for (let i = 0; i < partesFiltro.length; i++) {
            if (i >= partesHora.length) return false;
            if (!partesHora[i].startsWith(partesFiltro[i])) return false;
          }
          
          return true;
        },
      },
      {
        Header: 'Plano',
        accessor: 'plano',
        minWidth: 60,
        maxWidth: 80,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        sortable: false,
      },
      {
        Header: 'Modo Operação',
        accessor: 'modo_operacao',
        minWidth: 100,
        maxWidth: 130,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        sortable: false,
        Cell: props => {
          if (props.original.tipo !== 'normal') return '';

          const modoOperacao = props.original.modo_operacao;
          if (!modoOperacao) return '';

          // Garantir que sempre renderizamos uma string
          let textoModoOperacao = '';

          if (typeof modoOperacao === 'object') {
            textoModoOperacao = modoOperacao.descricao || modoOperacao.nome || String(modoOperacao.id || '');
          } else {
            textoModoOperacao = String(modoOperacao);
          }

          return (
            <span
              style={{
                fontSize: '12px',
                color: '#000',
              }}
            >
              {textoModoOperacao}
            </span>
          );
        },
      },
      {
        Header: 'Tipo',
        accessor: 'tipo_label',
        minWidth: 120,
        maxWidth: 150,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        sortable: false,
        Cell: props => {
          const tipo = props.original.tipo;
          const tipoLabel = props.value || props.original.tipo_label;

          let bg = '#e9e9e9'; // default
          if (tipo === 'normal') bg = '#d8d8d8';
          // mais escuro
          else if (tipo === 'maximo') bg = '#e6e6e6';
          // médio
          else if (tipo === 'executado') bg = '#f3f3f3'; // mais claro

          return (
            <span
              style={{
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '12px',
                backgroundColor: bg,
                color: '#000',
              }}
            >
              {String(tipoLabel || '')}
            </span>
          );
        },
      },
    ];

    // Descobrir quais intervalos são adaptativos baseado nos dados
    const intervalosAdaptativos = this.getIntervalosAdaptativos(list);
    // Criar array de colunas apenas para os intervalos adaptativos
    const intervalosColumns = [];
    intervalosAdaptativos.forEach(numeroIntervalo => {
      const apenasNumeroIntervalo = parseInt(numeroIntervalo);
      intervalosColumns.push({
        Header: `Int. ${apenasNumeroIntervalo}`,
        accessor: `intervalo_${apenasNumeroIntervalo}`,
        minWidth: 50,
        maxWidth: 65,
        style: { fontSize: '11px', textAlign: 'center' },
        sortable: false,
        filterable: false,
        Cell: props => {
          if (!props.original.intervalos) return '';

          const intervalo = props.original.intervalos.find(int => int.numero === apenasNumeroIntervalo);
          if (!intervalo) return '';

          const valor = props.original.tipo === 'maximo' ? intervalo.tempo_programado : intervalo.tempo_executado;
          const modoIntervalo = intervalo.modo;

          // Para linha de tempos normais, mostrar apenas o tempo sem modo
          if (props.original.tipo === 'normal') {
            return (
              <div
                style={{
                  textAlign: 'center',
                  fontFamily: 'monospace',
                }}
              >
                {parseInt(intervalo.tempo_programado) || 0}s
              </div>
            );
          }

          // Descrição e cor do modo
          const modoDescricao =
            {
              p: 'Adaptativo Coletivo',
              i: 'Atuado Adap. Individual',
              I: 'Adaptativo Individual',
              a: 'Atuado Adap. Coletivo',
              A: 'Atuado Adap. Coletivo (Maiúsculo)',
              N: 'Tempo Normal',
              // Adicione outros modos conforme necessário
            }[modoIntervalo] || 'Desconhecido';

          return (
            <TooltipWrapper tooltipText={modoDescricao}>
              <div
                style={{
                  textAlign: 'center',
                  fontFamily: 'monospace',
                }}
              >
                {parseInt(valor) || 0}s{' - '} {modoIntervalo}
              </div>
            </TooltipWrapper>
          );
        },
      });
    });

    // Adicionar colunas dos intervalos adaptativos diretamente (sem agrupamento)
    if (intervalosColumns.length > 0) {
      columns.push(...intervalosColumns);
    }

    // Adicionar coluna T. Sobra
    columns.push({
      Header: 'T. Sobra',
      accessor: 'tempo_sobra',
      minWidth: 80,
      maxWidth: 100,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só calcular para linha executado
        if (props.original.tipo !== 'executado') return '';

        if (!props.original.intervalos || !Array.isArray(props.original.intervalos)) return '0s';

        try {
          // Soma dos tempos programados com validação
          const somaProgramado = props.original.intervalos.reduce((sum, int) => {
            if (!int || typeof int !== 'object') return sum;
            const tempo = parseInt(int.tempo_programado) || 0;
            return sum + tempo;
          }, 0);

          // Soma dos tempos executados com validação
          const somaExecutado = props.original.intervalos.reduce((sum, int) => {
            if (!int || typeof int !== 'object') return sum;
            const tempo = parseInt(int.tempo_executado) || 0;
            return sum + tempo;
          }, 0);

          const sobra = somaProgramado - somaExecutado;

          // Verificar se o resultado é um número válido
          if (isNaN(sobra)) {
            console.warn('Valor NaN detectado na coluna T. Sobra:', {
              somaProgramado,
              somaExecutado,
              intervalos: props.original.intervalos,
            });
            return '0s';
          }

          return (
            <span
              style={{
                fontSize: '12px',
                color: '#000',
              }}
            >
              {sobra}s
            </span>
          );
        } catch (error) {
          console.error('Erro ao calcular T. Sobra:', error);
          return '0s';
        }
      },
    });

    // Adicionar coluna T. T. Ciclo (tempo programado do ciclo)
    columns.push({
      Header: 'T. T. Ciclo',
      accessor: 'tempo_ciclo',
      minWidth: 80,
      maxWidth: 100,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só mostrar para linha executado
        if (props.original.tipo !== 'executado') return '';

        // Usar o tempo_programado do backend com validação
        const tempoProgramado = parseInt(props.original.tempo_programado) || 0;

        // Verificar se é um número válido
        if (isNaN(tempoProgramado)) {
          console.warn('Valor NaN detectado na coluna T. T. Ciclo:', props.original.tempo_programado);
          return '0s';
        }

        return (
          <span
            style={{
              fontSize: '12px',
              color: '#000',
            }}
          >
            {tempoProgramado}s
          </span>
        );
      },
    });

    // Adicionar coluna Tempo Total do Ciclo
    columns.push({
      Header: 'T. Ciclo Executado',
      accessor: 'tempo_total_ciclo',
      minWidth: 100,
      maxWidth: 130,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só mostrar para linha executado
        if (props.original.tipo !== 'executado') return '';

        // Usar o dado que vem do backend com validação
        const tempoTotal = parseInt(props.original.tempo_total_ciclo) || 0;

        // Verificar se é um número válido
        if (isNaN(tempoTotal)) {
          console.warn('Valor NaN detectado na coluna T. Ciclo Executado:', props.original.tempo_total_ciclo);
          return '0s';
        }

        return (
          <span
            style={{
              fontSize: '12px',
              color: '#000',
            }}
          >
            {tempoTotal}s
          </span>
        );
      },
    });

    return columns;
  }

  // Função para descobrir quais intervalos são adaptativos baseado nos dados
  getIntervalosAdaptativos = dados => {
    if (!dados || !Array.isArray(dados) || dados.length === 0) {
      return [];
    }

    const intervalosAdaptativos = new Set();

    dados.forEach(ciclo => {
      if (ciclo.intervalos && Array.isArray(ciclo.intervalos)) {
        ciclo.intervalos.forEach(intervalo => {
          if (intervalo.numero && intervalo.modo) {
            intervalosAdaptativos.add(intervalo.numero);
          }
        });
      }
    });

    // Converter Set para Array e ordenar numericamente
    return Array.from(intervalosAdaptativos).sort((a, b) => a - b);
  };

  // Função para processar os dados e criar três linhas por ciclo (normal, programado, executado)
  processarDados = dados => {
    const dadosProcessados = [];

    dados.forEach((ciclo, index) => {
      try {
        // Validar dados básicos do ciclo
        if (!ciclo || typeof ciclo !== 'object') {
          console.warn('Ciclo inválido detectado:', ciclo);
          return;
        }

        // Garantir que campos essenciais são strings
        const dataValidada = String(ciclo.data || '');
        const horaValidada = String(ciclo.hora || '');
        const planoValidado = String(ciclo.plano || '');

        // Recalcular status do ciclo baseado na nova interpretação
        const statusRecalculado = this.recalcularStatusCiclo(ciclo);

        // Criar um identificador único para ordenação que mantém as três linhas juntas
        // Usar timestamp para ordenação mais precisa (mais recente no topo por padrão)
        const dataHora = `${dataValidada} ${horaValidada}`;
        const timestamp = new Date(
          `${dataValidada
            .split('/')
            .reverse()
            .join('-')} ${horaValidada}`,
        ).getTime();

        // Verificar se timestamp é válido
        if (isNaN(timestamp)) {
          console.warn('Timestamp inválido para ciclo:', { data: dataValidada, hora: horaValidada });
          return;
        }

        // Criar chave de ordenação: timestamp_invertido para mais recente ficar no topo + índice para garantir ordem
        const timestampInvertido = 9999999999999 - timestamp; // Inverter para mais recente ficar no topo
        const ordenacaoKey = `${String(timestampInvertido).padStart(15, '0')}_${String(index).padStart(6, '0')}`;

        // Criar intervalos com tempos normais
        const intervalosNormais = [];
        ciclo.intervalos.forEach(intervalo => {
          const tempoNormal = parseFloat(intervalo.tempo_normal) || 0;
          if (tempoNormal > 0) {
            // Só adiciona se tem tempo normal
            intervalosNormais.push({
              numero: intervalo.numero,
              modo: 'N', // Modo Normal
              tempo_programado: tempoNormal,
              tempo_executado: 0, // Não aplicável para tempos normais
              extensao: 0,
            });
          }
        });

        dadosProcessados.push({
          ...ciclo,
          data: dataValidada,
          hora: horaValidada,
          plano: planoValidado,
          tipo: 'normal',
          tipo_label: 'Tempo Normal',
          intervalos: intervalosNormais, // pode estar vazio
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          ordenacao_key: `${ordenacaoKey}_0`, // Garante que linha normal vem primeiro
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });

        // Linha 2: Tempos programados (sem dados redundantes)
        dadosProcessados.push({
          ...ciclo,
          data: '', // Vazio para evitar redundância
          hora: '', // Vazio para evitar redundância
          plano: '', // Vazio para evitar redundância
          modo_operacao: { descricao: '' }, // Vazio para evitar redundância
          tipo: 'maximo',
          tipo_label: 'Tempo Ext. Programado',
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          ordenacao_key: `${ordenacaoKey}_1`, // Garante que linha programado vem depois
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });

        // Linha 3: Tempos executados (sem dados redundantes)
        dadosProcessados.push({
          ...ciclo,
          data: '', // Vazio para evitar redundância
          hora: '', // Vazio para evitar redundância
          plano: '', // Vazio para evitar redundância
          modo_operacao: { descricao: '' }, // Vazio para evitar redundância
          tipo: 'executado',
          tipo_label: 'Tempo Ext. Executado',
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          status_ciclo: statusRecalculado, // Usar status recalculado
          ordenacao_key: `${ordenacaoKey}_2`, // Garante que linha executado vem por último
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });
      } catch (error) {
        console.error('Erro ao processar ciclo:', error, ciclo);
      }
    });

    return dadosProcessados;
  };

  // Função para recalcular o status do ciclo baseado na nova interpretação
  recalcularStatusCiclo = ciclo => {
    if (!ciclo.intervalos || ciclo.intervalos.length === 0) return 'Normal';

    const statusIntervalos = ciclo.intervalos.map(intervalo => {
      // Se tempo executado for 0, consideramos normal (não houve extensão)
      if (intervalo.tempo_executado === 0) {
        return 'normal';
      }

      // Só há extensão se tempo executado > 0 (nunca há redução)
      const tempoExecutado = intervalo.tempo_executado || 0;
      if (tempoExecutado > 0) return 'extensão';
      return 'normal';
    });

    const temExtensao = statusIntervalos.includes('extensão');
    return temExtensao ? 'Extensão' : 'Normal';
  };

  render() {
    const { list, loading, error } = this.props;
    const columns = this.carregaColunas();
    const controladorId = getConfig('cont');

    // Verificar se há controlador selecionado
    if (!controladorId || controladorId === 0) {
      return (
        <div className="table-container" style={{ marginTop: '20px', textAlign: 'center', padding: '40px' }}>
          <div style={{ color: '#666', fontSize: '18px' }}>
            <i className="fa fa-info-circle" style={{ marginRight: '10px', fontSize: '20px' }} />
            Selecione um controlador para visualizar os logs de extensões adaptativas
          </div>
        </div>
      );
    }

    // Estado de loading
    if (loading) {
      return (
        <div className="table-container" style={{ marginTop: '20px', textAlign: 'center', padding: '40px' }}>
          <div style={{ color: '#666', fontSize: '18px' }}>
            <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px', fontSize: '20px' }} />
            Carregando logs...
          </div>
        </div>
      );
    }

    // Estado de erro
    if (error) {
      return (
        <div className="table-container" style={{ marginTop: '20px', textAlign: 'center', padding: '40px' }}>
          <div style={{ color: '#d9534f', fontSize: '18px' }}>
            <i className="fa fa-exclamation-circle" style={{ marginRight: '10px', fontSize: '20px' }} />
            Erro ao carregar dados: {error}
          </div>
        </div>
      );
    }

    // Lista vazia
    if (!list || list.length === 0) {
      return (
        <div className="table-container" style={{ marginTop: '20px', textAlign: 'center', padding: '40px' }}>
          <div style={{ color: '#666', fontSize: '18px' }}>
            <i className="fa fa-inbox" style={{ marginRight: '10px', fontSize: '20px' }} />
            Nenhum log de extensão encontrado para este controlador
          </div>
        </div>
      );
    }

    // Processar dados para criar duas linhas por ciclo
    const dadosProcessados = this.processarDados(list);

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <ReactTableGT2A
          data={dadosProcessados}
          columns={columns}
          defaultPageSize={30}
          showPagination
          filterable={true}
          defaultSorted={[
            {
              id: 'data',
              desc: false,
            },
          ]}
          style={{
            fontSize: '13px',
            width: '100%',
          }}
          className="-striped -highlight responsive-table"
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.original) {
              const cicloIndex = rowInfo.original.cicloIndex;
              const isEvenCycle = cicloIndex % 2 === 0;

              return {
                style: {
                  backgroundColor: isEvenCycle ? '#f9f9f9' : '#ffffff',
                },
              };
            }
            return {};
          }}
          resizable={false} // Desabilitar redimensionamento manual das colunas
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.logAdaptativo.list,
  loading: state.logAdaptativo.loading,
  error: state.logAdaptativo.error,
});

export default connect(mapStateToProps)(LogAdaptativoList);
